import { Col, Row } from 'antd';
import React, { FC, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import { Page } from 'components/molecules/page';
import {
  useHasSetupSpacesInTemplate,
  setupActiveSpace,
} from 'data/templates/projects';
import { TemplateDetailHeader } from '../../commons';
import { ProjectTemplateTabDetail } from './details';
import { ProjectTemplateSpacesLeftNav } from './left-nav';
import { SettingUpProjectPlanIntermediateScreen } from './setting-up';
import { ProjectSpacesTemplateToolBar } from './template-sapces-toolbar';

const LeftColWidth = 256;

const Wrapper = styled(Row)`
  height: calc(100vh - 170px);
`;

const LeftCol = styled(Col)`
  box-shadow: var(--shadow-04);
  height: 100%;
  overflow: hidden;
  overflow-y: auto;
  padding: var(--layout-01);
  padding-left: var(--left-spacing);
  width: ${LeftColWidth}px;
`;

const RightCol = styled(Col)`
  flex: 1;
  padding: 1px;
  width: calc(100% - ${LeftColWidth}px);
  height: 100%;
`;

export const ProjectTemplateSpaces: FC = () => {
  const dispatch = useDispatch();
  const spaceSetupState = useHasSetupSpacesInTemplate();
  const { spaceId } = useParams<{ spaceId: string }>();

  useEffect(() => {
    dispatch(
      setupActiveSpace({
        spaceId: parseInt(spaceId, 10),
      }),
    );
  }, [dispatch, spaceId]);

  return spaceSetupState === 'IN_PROGRESS' ||
    spaceSetupState === 'YET_TO_START' ? (
    <SettingUpProjectPlanIntermediateScreen />
  ) : (
    <Page>
      <TemplateDetailHeader />
      <Page.Content>
        <ProjectSpacesTemplateToolBar />
        <Wrapper>
          <LeftCol>
            <ProjectTemplateSpacesLeftNav />
          </LeftCol>
          <RightCol>
            <ProjectTemplateTabDetail />
          </RightCol>
        </Wrapper>
      </Page.Content>
    </Page>
  );
};
